import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/outfit/700.css';
import '@aws-amplify/ui-react/styles.css';
import '@aws-amplify/ui-react-liveness/styles.css';
import '@/styles/index.sass';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { Amplify } from 'aws-amplify';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from '@/App';
import { loadDemoConfig } from '@/lib/config';
import { theme } from '@/theme';

async function bootstrap(): Promise<void> {
  const config = await loadDemoConfig();

  Amplify.configure({
    Auth: {
      Cognito: {
        identityPoolId: config.identityPoolId,
        allowGuestAccess: true,
      },
    },
  });

  const root = document.getElementById('root');
  if (!root) throw new Error('root element not found');

  // Sem StrictMode: o FaceLivenessDetector usa WebRTC/streams que quebram no
  // double-mount (amplify-ui#6245) — mesma decisão do entry-onboarding.
  createRoot(root).render(
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>,
  );
}

function renderBootstrapFailure(): void {
  const root = document.getElementById('root');
  if (!root) return;
  root.innerHTML = '';
  const box = document.createElement('div');
  box.setAttribute('role', 'alert');
  box.style.cssText =
    'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;' +
    'min-height:100dvh;padding:24px;text-align:center;font-family:Outfit,system-ui,sans-serif';
  const title = document.createElement('h1');
  title.textContent = 'Não foi possível carregar o demo';
  title.style.cssText = 'font-size:20px;font-weight:600;margin:0';
  const detail = document.createElement('p');
  detail.textContent = 'O servidor do demo não respondeu. Confira se o BFF está no ar e tente de novo.';
  detail.style.cssText = 'margin:0;max-width:32ch;opacity:.75';
  const retry = document.createElement('button');
  retry.type = 'button';
  retry.textContent = 'Tentar novamente';
  retry.style.cssText =
    'border:0;border-radius:999px;padding:12px 28px;font:inherit;font-weight:600;background:#171918;color:#fff;cursor:pointer';
  retry.addEventListener('click', () => window.location.reload());
  box.append(title, detail, retry);
  root.append(box);
}

void bootstrap().catch((error: unknown) => {
  renderBootstrapFailure();
  throw error;
});
